/* istanbul ignore file */
export const headers = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
});
